const PRODUCT_PLACEHOLDER = /\[insert product\]/gi;

// Personas that should get their product group injected. Leadership is intentionally excluded.
export const PRODUCT_INJECTION_PERSONAS = ["SALESREP", "RBD"];

// Accepts a string, a comma-separated string, an array of strings, or an array of { name } objects
const normalizeProductGroups = (value) => {
  if (!value) return [];
  const list = Array.isArray(value) ? value : String(value).split(",");
  const names = list.map((v) => (typeof v === "string" ? v : v?.name)?.trim());
  return [...new Set(names.filter(Boolean))];
};

// ["A"] -> "A" | ["A","B"] -> "A and B" | ["A","B","C"] -> "A, B and C"
export const formatProductGroups = (value) => {
  const groups = normalizeProductGroups(value);
  if (groups.length <= 1) return groups[0] ?? "";
  return `${groups.slice(0, -1).join(", ")} and ${groups[groups.length - 1]}`;
};

// Recursively replaces [insert product] in strings, arrays and objects.
// Returns new objects, so the original prompt data is never mutated.
export const injectProductGroups = (data, productGroups) => {
  const productText = formatProductGroups(productGroups);
  if (!productText) return data; // nothing to inject, so keep the placeholder

  const walk = (node) => {
    if (typeof node === "string")
      return node.replace(PRODUCT_PLACEHOLDER, productText);
    if (Array.isArray(node)) return node.map(walk);
    if (node && typeof node === "object") {
      return Object.fromEntries(
        Object.entries(node).map(([k, v]) => [k, walk(v)]),
      );
    }
    return node;
  };

  return walk(data);
};
